import { SET_OUTPUT } from "./types"

export const setOutput = (details) => async (dispatch) => {
    dispatch({
        type: SET_OUTPUT,
        payload: details
    })
}
